// GeneralLoginPage.js
import React from 'react';
import { Form, Input, Button, Typography, Row, Col, Card, message } from 'antd';
import Layout from '../components/layout';
import { login } from '../services/authService';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const GeneralLoginPage = () => {
    const navigate = useNavigate();

    const handleLogin = async (values) => {
        try {
            const { username, password } = values;
            const data = await login(username, password);

            console.log(data, 'the user DATA');
            if (data.approved) {
                // Store token in local storage
                localStorage.setItem('token', data.token);

                // Store the token in local storage
                localStorage.setItem('userToken', data.token);
                localStorage.setItem('role', data.role);


                message.success('Login successful!');
                navigate('/certificateSelection')

            }else {
                console.log("Not approved")
                navigate("/notApproved")
            }
            // Redirect or perform further actions after successful login
        } catch (error) {
            message.error(error.message || 'Login failed. Please try again.');
        }
    };

    return (
        <Layout>
            <Row justify="center" align="middle" style={{ minHeight: '100vh', padding: '24px' }}>
                <Col xs={24} sm={16} md={12} lg={8}>
                    <Card
                        style={{
                            padding: '24px',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                        bordered
                    >
                        <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
                            User Login
                        </Title>
                        <Form name="generalLogin" layout="vertical" onFinish={handleLogin}>
                            <Form.Item
                                name="username"
                                label="Username"
                                rules={[{ required: true, message: 'Please input your username!' }]}
                            >
                                <Input placeholder="Enter your username" />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                label="Password"
                                rules={[{ required: true, message: 'Please input your password!' }]}
                            >
                                <Input.Password placeholder="Enter your password" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    Login
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default GeneralLoginPage;
